import gql from 'graphql-tag';

const getMonthlySubmissionsQuery = gql`
  query GetMonthlySubmissions($organisationId: String!, $teamId: String) {
    getMonthlySubmissions(organisationId: $organisationId, teamId: $teamId) {
      date
      submissions
    }
  }
`;

export default ((organisationId) => ({
  query: getMonthlySubmissionsQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: (teamId) => ({
    organisationId,
    teamId
  })
}));